import { render, staticRenderFns } from "./home-travel.vue?vue&type=template&id=8820c4fc&scoped=true"
var script = {}
import style0 from "./home-travel.vue?vue&type=style&index=0&id=8820c4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8820c4fc",
  null
  
)

export default component.exports